import {PolylineEdge, PolylineEdgeModel} from '@logicflow/core';

// 自定义审批边模型
class ApprovalEdgeModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);

    if (!this.properties || Object.keys(this.properties).length === 0) {
      this.properties = {
        type: 'submit',
        condition: '',
        status: 'pending',
      };
    }

    const typeNames = {
      submit: '提交',
      reject: '拒绝',
    };

    this.text = {
      value: typeNames[this.properties.type] || '',
      x: 0,
      y: 0,
      draggable: false,
    };
  }

  _isTargetCarbon() {
    const props = this.properties || {};
    if (props._toCarbon) return true;
    if (!this.graphModel || !this.targetNodeId) return false;
    const target = this.graphModel.getNodeModelById(this.targetNodeId);
    return !!(target && target.type === 'carbon_node');
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const {type, status} = this.properties || {};

    switch (type) {
      case 'submit':
        style.stroke = '#1890ff';
        style.arrow = 'block';
        break;
      case 'reject':
        style.stroke = '#ff4d4f';
        style.arrow = 'hollow';
        break;
      default:
        style.stroke = '#333';
    }

    // 指向抄送节点：始终虚线；其它边 pending 时虚线
    if (this._isTargetCarbon()) {
      style.strokeDasharray = '6 4';
    } else if (status === 'pending') {
      style.strokeDasharray = '5 5';
    } else {
      style.strokeDasharray = 'none';
    }

    return style;
  }

  getTextStyle() {
    const style = super.getTextStyle();
    style.fontSize = 12;
    style.color = '#666';
    return style;
  }
}

export default {
  type: 'approval-edge',
  view: PolylineEdge,
  model: ApprovalEdgeModel,
};
